import { extensions } from '../extensions/Extensions.mjs';
import { spritesheetAsset } from './spritesheetAsset.mjs';

"use strict";
extensions.add(spritesheetAsset);
//# sourceMappingURL=init.mjs.map
